import _createClass from "@babel/runtime/helpers/createClass";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
export var EventType = /*#__PURE__*/function (EventType) {
  EventType["DocumentChange"] = "documentChange";
  EventType["LoadingChange"] = "loadingChange";
  EventType["Error"] = "error";
  EventType["Closed"] = "closed";
  EventType["Print"] = "print";
  EventType["AuthFailure"] = "authFailure";
  EventType["LoadedDocumentChange"] = "loadedDocumentChange";
  EventType["AnnotationsChange"] = "annotationChange";
  EventType["ZoomChange"] = "zoomChange";
  EventType["DocumentMetadataLoaded"] = "documentMetadataLoaded";
  EventType["DocumentUpdateAction"] = "documentUpdateAction";
  EventType["CustomButtonAction"] = "customButtonAction";
  EventType["PrintModalClosed"] = "printModalClosed";
  EventType["WatermarkModalOpened"] = "watermarkModalOpened";
  EventType["WatermarkModalClosed"] = "watermarkModalClosed";
  EventType["WatermarkChanged"] = "watermarkChanged";
  EventType["ColorChanged"] = "colorChanged";
  EventType["DownloadModalClosed"] = "downloadModalClosed";
  EventType["DocumentDownloaded"] = "downloadDocument";
  EventType["PasswordSubmitted"] = "passwordSubmitted";
  EventType["WebViewerLoaded"] = "onWebViewerLoaded";
  EventType["DocumentContentChanged"] = "DocumentContentChanged";
  EventType["DocumentPageRemoved"] = "DocumentPageRemoved";
  EventType["TotalPages"] = "TotalPages";
  EventType["DocumentBlob"] = "DocumentBlob";
  EventType["DocumentPageData"] = "DocumentPageData";
  EventType["DocumentLoadFailed"] = "onDocumentLoadFailed";
  EventType["DocumentNotSupported"] = "onDocumentNotSupported";
  EventType["ExistingDocumentLoaded"] = "onExistingDocumentLoaded";
  EventType["NewPageInserted"] = "onNewPageInserted";
  EventType["PasswordModal"] = "passwordModal";
  EventType["DocumentAnnotations"] = "documentAnnotations";
  return EventType;
}({});
export var PdfTronElement = /*#__PURE__*/function (PdfTronElement) {
  PdfTronElement["header"] = "header";
  PdfTronElement["leftPanelButton"] = "leftPanelButton";
  PdfTronElement["viewControlsButton"] = "viewControlsButton";
  PdfTronElement["panToolButton"] = "panToolButton";
  PdfTronElement["selectToolButton"] = "selectToolButton";
  PdfTronElement["textSelectButton"] = "textSelectButton";
  PdfTronElement["fitButton"] = "fitButton";
  PdfTronElement["zoomOutButton"] = "zoomOutButton";
  PdfTronElement["zoomInButton"] = "zoomInButton";
  PdfTronElement["zoomOverlayButton"] = "zoomOverlayButton";
  PdfTronElement["freeHandToolGroupButton"] = "freeHandToolGroupButton";
  PdfTronElement["highlightToolGroupButton"] = "highlightToolGroupButton";
  PdfTronElement["freeHandToolButton"] = "freeHandToolButton";
  PdfTronElement["freeHandToolButton2"] = "freeHandToolButton2";
  PdfTronElement["freeHandToolButton3"] = "freeHandToolButton3";
  PdfTronElement["freeHandToolButton4"] = "freeHandToolButton4";
  PdfTronElement["textToolGroupButton"] = "textToolGroupButton";
  PdfTronElement["freeTextToolGroupButton"] = "freeTextToolGroupButton";
  PdfTronElement["freeTextToolButton"] = "freeTextToolButton";
  PdfTronElement["freeTextToolButton2"] = "freeTextToolButton2";
  PdfTronElement["freeTextToolButton3"] = "freeTextToolButton3";
  PdfTronElement["freeTextToolButton4"] = "freeTextToolButton4";
  PdfTronElement["stickyToolGroupButton"] = "stickyToolGroupButton";
  PdfTronElement["highlightToolButton"] = "highlightToolButton";
  PdfTronElement["highlightToolButton2"] = "highlightToolButton2";
  PdfTronElement["highlightToolButton3"] = "highlightToolButton3";
  PdfTronElement["highlightToolButton4"] = "highlightToolButton4";
  PdfTronElement["freeHandHighlightToolGroupButton"] = "freeHandHighlightToolGroupButton";
  PdfTronElement["freeHandHighlightToolButton2"] = "freeHandHighlightToolButton2";
  PdfTronElement["freeHandHighlightToolButton3"] = "freeHandHighlightToolButton3";
  PdfTronElement["freeHandHighlightToolButton4"] = "freeHandHighlightToolButton4";
  PdfTronElement["underlineToolGroupButton"] = "underlineToolGroupButton";
  PdfTronElement["underlineToolButton"] = "underlineToolButton";
  PdfTronElement["underlineToolButton2"] = "underlineToolButton2";
  PdfTronElement["underlineToolButton3"] = "underlineToolButton3";
  PdfTronElement["underlineToolButton4"] = "underlineToolButton4";
  PdfTronElement["squigglyToolButton"] = "squigglyToolButton";
  PdfTronElement["squigglyToolButton2"] = "squigglyToolButton2";
  PdfTronElement["squigglyToolButton3"] = "squigglyToolButton3";
  PdfTronElement["squigglyToolButton4"] = "squigglyToolButton4";
  PdfTronElement["strikeoutToolGroupButton"] = "strikeoutToolGroupButton";
  PdfTronElement["strikeoutToolButton"] = "strikeoutToolButton";
  PdfTronElement["strikeoutToolButton2"] = "strikeoutToolButton2";
  PdfTronElement["strikeoutToolButton3"] = "strikeoutToolButton3";
  PdfTronElement["strikeoutToolButton4"] = "strikeoutToolButton4";
  PdfTronElement["shapeToolGroupButton"] = "shapeToolGroupButton";
  PdfTronElement["rectangleToolButton"] = "rectangleToolButton";
  PdfTronElement["ellipseToolButton"] = "ellipseToolButton";
  PdfTronElement["lineToolButton"] = "lineToolButton";
  PdfTronElement["arrowToolButton"] = "arrowToolButton";
  PdfTronElement["polylineToolButton"] = "polylineToolButton";
  PdfTronElement["polygonToolButton"] = "polygonToolButton";
  PdfTronElement["cloudToolButton"] = "cloudToolButton";
  PdfTronElement["eraserToolButton"] = "eraserToolButton";
  PdfTronElement["signatureToolButton"] = "signatureToolButton";
  PdfTronElement["stickyToolButton"] = "stickyToolButton";
  PdfTronElement["miscToolGroupButton"] = "miscToolGroupButton";
  PdfTronElement["calloutToolButton"] = "calloutToolButton";
  PdfTronElement["stampToolButton"] = "stampToolButton";
  PdfTronElement["rubberStampToolButton"] = "rubberStampToolButton";
  PdfTronElement["fileAttachmentToolButton"] = "fileAttachmentToolButton";
  PdfTronElement["cropToolButton"] = "cropToolButton";
  PdfTronElement["toolsButton"] = "toolsButton";
  PdfTronElement["toolsHeader"] = "toolsHeader";
  PdfTronElement["undoButton"] = "undoButton";
  PdfTronElement["redoButton"] = "redoButton";
  PdfTronElement["searchButton"] = "searchButton";
  PdfTronElement["menuButton"] = "menuButton";
  PdfTronElement["leftPanel"] = "leftPanel";
  PdfTronElement["noteState"] = "noteState";
  PdfTronElement["notesPanelButton"] = "notesPanelButton";
  PdfTronElement["notesPanel"] = "notesPanel";
  PdfTronElement["toggleNotesButton"] = "toggleNotesButton";
  PdfTronElement["thumbnailsPanelButton"] = "thumbnailsPanelButton";
  PdfTronElement["thumbnailsPanel"] = "thumbnailsPanel";
  PdfTronElement["thumbnailControl"] = "thumbnailControl";
  PdfTronElement["documentControl"] = "documentControl";
  PdfTronElement["outlinesPanelButton"] = "outlinesPanelButton";
  PdfTronElement["outlinesPanel"] = "outlinesPanel";
  PdfTronElement["layersPanelButton"] = "layersPanelButton";
  PdfTronElement["layersPanel"] = "layersPanel";
  PdfTronElement["bookmarksPanelButton"] = "bookmarksPanelButton";
  PdfTronElement["bookmarksPanel"] = "bookmarksPanel";
  PdfTronElement["searchPanel"] = "searchPanel";
  PdfTronElement["viewControlsOverlay"] = "viewControlsOverlay";
  PdfTronElement["defaultPageTransitionButton"] = "defaultPageTransitionButton";
  PdfTronElement["continuousPageTransitionButton"] = "continuousPageTransitionButton";
  PdfTronElement["singleLayoutButton"] = "singleLayoutButton";
  PdfTronElement["doubleLayoutButton"] = "doubleLayoutButton";
  PdfTronElement["coverLayoutButton"] = "coverLayoutButton";
  PdfTronElement["rotateCounterClockwiseButton"] = "rotateCounterClockwiseButton";
  PdfTronElement["rotateClockwiseButton"] = "rotateClockwiseButton";
  PdfTronElement["menuOverlay"] = "menuOverlay";
  PdfTronElement["filePickerButton"] = "filePickerButton";
  PdfTronElement["fullScreenButton"] = "fullScreenButton";
  PdfTronElement["downloadButton"] = "downloadButton";
  PdfTronElement["printButton"] = "printButton";
  PdfTronElement["pageNavOverlay"] = "pageNavOverlay";
  PdfTronElement["toolsOverlay"] = "toolsOverlay";
  PdfTronElement["searchOverlay"] = "searchOverlay";
  PdfTronElement["annotationPopup"] = "annotationPopup";
  PdfTronElement["applyWatermark"] = "applyWatermark";
  PdfTronElement["annotationCommentButton"] = "annotationCommentButton";
  PdfTronElement["annotationStyleEditButton"] = "annotationStyleEditButton";
  PdfTronElement["annotationDeleteButton"] = "annotationDeleteButton";
  PdfTronElement["annotationCropButton"] = "annotationCropButton";
  PdfTronElement["annotationRedactButton"] = "annotationRedactButton";
  PdfTronElement["annotationGroupButton"] = "annotationGroupButton";
  PdfTronElement["annotationUngroupButton"] = "annotationUngroupButton";
  PdfTronElement["calibrateButton"] = "calibrateButton";
  PdfTronElement["linkButton"] = "linkButton";
  PdfTronElement["fileAttachmentDownload"] = "fileAttachmentDownload";
  PdfTronElement["annotationStylePopup"] = "annotationStylePopup";
  PdfTronElement["toolStylePopup"] = "toolStylePopup";
  PdfTronElement["stylePopup"] = "stylePopup";
  PdfTronElement["colorPalette"] = "colorPalette";
  PdfTronElement["opacitySlider"] = "opacitySlider";
  PdfTronElement["textPopup"] = "textPopup";
  PdfTronElement["copyTextButton"] = "copyTextButton";
  PdfTronElement["textHighlightToolButton"] = "textHighlightToolButton";
  PdfTronElement["textUnderlineToolButton"] = "textUnderlineToolButton";
  PdfTronElement["textSquigglyToolButton"] = "textSquigglyToolButton";
  PdfTronElement["textStrikeoutToolButton"] = "textStrikeoutToolButton";
  PdfTronElement["contextMenuPopup"] = "contextMenuPopup";
  PdfTronElement["signatureModal"] = "signatureModal";
  PdfTronElement["signatureModalCloseButton"] = "signatureModalCloseButton";
  PdfTronElement["inkSignaturePanelButton"] = "inkSignaturePanelButton";
  PdfTronElement["textSignaturePanelButton"] = "textSignaturePanelButton";
  PdfTronElement["imageSignaturePanelButton"] = "imageSignaturePanelButton";
  PdfTronElement["filterModal"] = "filterModal";
  PdfTronElement["printModal"] = "printModal";
  PdfTronElement["loadingModal"] = "loadingModal";
  PdfTronElement["errorModal"] = "errorModal";
  PdfTronElement["passwordModal"] = "passwordModal";
  PdfTronElement["progressModal"] = "progressModal";
  PdfTronElement["toolbarGroupView"] = "toolbarGroup-View";
  PdfTronElement["toolbarGroupAnnotate"] = "toolbarGroup-Annotate";
  PdfTronElement["toolbarGroupShapes"] = "toolbarGroup-Shapes";
  PdfTronElement["toolbarGroupInsert"] = "toolbarGroup-Insert";
  PdfTronElement["toolbarGroupMeasure"] = "toolbarGroup-Measure";
  PdfTronElement["toolbarGroupEdit"] = "toolbarGroup-Edit";
  PdfTronElement["cropToolGroupButton"] = "cropToolGroupButton";
  PdfTronElement["redactionToolGroupButton"] = "redactionToolGroupButton";
  PdfTronElement["ellipseToolGroupButton"] = "ellipseToolGroupButton";
  PdfTronElement["polygonToolGroupButton"] = "polygonToolGroupButton";
  PdfTronElement["polygonCloudToolGroupButton"] = "polygonCloudToolGroupButton";
  PdfTronElement["lineToolGroupButton"] = "lineToolGroupButton";
  PdfTronElement["polyLineToolGroupButton"] = "polyLineToolGroupButton";
  PdfTronElement["arrowToolGroupButton"] = "arrowToolGroupButton";
  PdfTronElement["distanceToolGroupButton"] = "distanceToolGroupButton";
  PdfTronElement["perimeterToolGroupButton"] = "perimeterToolGroupButton";
  PdfTronElement["areaToolGroupButton"] = "areaToolGroupButton";
  PdfTronElement["ellipseAreaToolGroupButton"] = "ellipseAreaToolGroupButton";
  PdfTronElement["rectangleAreaToolGroupButton"] = "rectangleAreaToolGroupButton";
  PdfTronElement["countToolGroupButton"] = "countToolGroupButton";
  PdfTronElement["ribbons"] = "ribbons";
  PdfTronElement["richTextPopup"] = "richTextPopup";
  PdfTronElement["signatureModalClearButton"] = "signatureModalClearButton";
  PdfTronElement["signatureModalSignButton"] = "signatureModalSignButton";
  PdfTronElement["notePopupState"] = "notePopupState";
  PdfTronElement["themeChangeButton"] = "themeChangeButton";
  PdfTronElement["richTextFormats"] = "richTextFormats";
  PdfTronElement["richTextBoldButton"] = "richTextBoldButton";
  PdfTronElement["richTextItalicButton"] = "richTextItalicButton";
  PdfTronElement["richTextUnderlineButton"] = "richTextUnderlineButton";
  PdfTronElement["richTextStrikeButton"] = "richTextStrikeButton";
  PdfTronElement["thumbRotateCounterClockwise"] = "thumbRotateCounterClockwise";
  PdfTronElement["thumbDelete"] = "thumbDelete";
  PdfTronElement["thumbRotateClockwise"] = "thumbRotateClockwise";
  PdfTronElement["thumbMultiDelete"] = "thumbMultiDelete";
  PdfTronElement["thumbMultiRotate"] = "thumbMultiRotate";
  PdfTronElement["thumbExtract"] = "thumbExtract";
  PdfTronElement["zoomOverlay"] = "zoomOverlay";
  PdfTronElement["freeHandHighlightToolButton"] = "freeHandHighlightToolButton";
  PdfTronElement["sortByDropDownItemColor"] = "dropdown-item-color";
  PdfTronElement["sortByDropDownItemStatus"] = "dropdown-item-status";
  PdfTronElement["signaturePanelButton"] = "signaturePanelButton";
  PdfTronElement["addNewOutlineButtonContainer"] = "addNewOutlineButtonContainer";
  PdfTronElement["editOutlineButton"] = "editOutlineButton";
  PdfTronElement["pageAdditionalControlsHeader"] = "pageAdditionalControlsHeader";
  PdfTronElement["moveToTop"] = "moveToTop";
  PdfTronElement["moveToBottom"] = "moveToBottom";
  PdfTronElement["pageRotationHeader"] = "pageRotationHeader";
  PdfTronElement["rotatePageClockwise"] = "rotatePageClockwise";
  PdfTronElement["rotatePageCounterClockwise"] = "rotatePageCounterClockwise";
  PdfTronElement["pageInsertionHeader"] = "pageInsertionHeader";
  PdfTronElement["insertPageAbove"] = "insertPageAbove";
  PdfTronElement["insertPageBelow"] = "insertPageBelow";
  PdfTronElement["pageManipulationHeader"] = "pageManipulationHeader";
  PdfTronElement["replacePage"] = "replacePage";
  PdfTronElement["extractPage"] = "extractPage";
  PdfTronElement["deletePage"] = "deletePage";
  PdfTronElement["thumbnailsControlRotatePopupTrigger"] = "thumbnailsControlRotatePopupTrigger";
  PdfTronElement["thumbnailsControlInsertPopupTrigger"] = "thumbnailsControlInsertPopupTrigger";
  PdfTronElement["thumbnailsControlInsertAbove"] = "thumbnailsControlInsertAbove";
  PdfTronElement["thumbnailsControlInsertBelow"] = "thumbnailsControlInsertBelow";
  PdfTronElement["thumbnailsControlReplace"] = "thumbnailsControlReplace";
  PdfTronElement["thumbnailsControlExtract"] = "thumbnailsControlExtract";
  PdfTronElement["thumbnailsControlDelete"] = "thumbnailsControlDelete";
  PdfTronElement["thumbnailsControlManipulatePopupTrigger"] = "thumbnailsControlManipulatePopupTrigger";
  PdfTronElement["pageManipulationOverlay"] = "pageManipulationOverlay";
  PdfTronElement["blueTickMark"] = "Blue Tick Mark";
  PdfTronElement["greenTickMark"] = "Green Tick Mark";
  PdfTronElement["redTickMark"] = "Red Tick Mark";
  PdfTronElement["yellowTickMark"] = "Yellow Tick Mark";
  return PdfTronElement;
}({});
export var defaultPdfTronElements = [PdfTronElement.header, PdfTronElement.panToolButton, PdfTronElement.selectToolButton, PdfTronElement.zoomInButton, PdfTronElement.zoomOutButton, PdfTronElement.zoomOverlayButton, PdfTronElement.zoomOverlay, PdfTronElement.searchButton, PdfTronElement.searchOverlay, PdfTronElement.searchPanel, PdfTronElement.printModal, PdfTronElement.passwordModal, PdfTronElement.textPopup, PdfTronElement.contextMenuPopup, PdfTronElement.applyWatermark, PdfTronElement.colorPalette, PdfTronElement.contextMenuPopup, PdfTronElement.annotationPopup];
export var viewControlAndMenuElements = [PdfTronElement.copyTextButton, PdfTronElement.menuButton, PdfTronElement.menuOverlay, PdfTronElement.downloadButton, PdfTronElement.printButton, PdfTronElement.fullScreenButton, PdfTronElement.viewControlsButton, PdfTronElement.viewControlsOverlay, PdfTronElement.continuousPageTransitionButton, PdfTronElement.defaultPageTransitionButton, PdfTronElement.rotateClockwiseButton, PdfTronElement.rotateCounterClockwiseButton, PdfTronElement.singleLayoutButton, PdfTronElement.doubleLayoutButton, PdfTronElement.coverLayoutButton];
export var thumbnailElements = [PdfTronElement.thumbnailControl, PdfTronElement.thumbRotateCounterClockwise, PdfTronElement.thumbRotateClockwise, PdfTronElement.thumbDelete, PdfTronElement.thumbMultiDelete, PdfTronElement.thumbMultiRotate];
export var cogMenu = [PdfTronElement.menuButton, PdfTronElement.menuOverlay, PdfTronElement.downloadButton, PdfTronElement.printButton, PdfTronElement.fullScreenButton];
export var pdfTronElementsToDisable = [PdfTronElement.noteState, PdfTronElement.progressModal, PdfTronElement.freeHandHighlightToolButton, PdfTronElement.sortByDropDownItemColor, PdfTronElement.sortByDropDownItemStatus, PdfTronElement.themeChangeButton, PdfTronElement.ribbons, PdfTronElement.signaturePanelButton];
export var SeparatorButton = /*#__PURE__*/function (SeparatorButton) {
  SeparatorButton["divider"] = "divider";
  SeparatorButton["spacer"] = "spacer";
  return SeparatorButton;
}({});
export var AnnotationAction = /*#__PURE__*/function (AnnotationAction) {
  AnnotationAction["Add"] = "add";
  AnnotationAction["Modify"] = "modify";
  AnnotationAction["Delete"] = "delete";
  return AnnotationAction;
}({});
export var AnnotatableFileMimeType = /*#__PURE__*/function (AnnotatableFileMimeType) {
  AnnotatableFileMimeType["Jpeg"] = "image/jpeg";
  AnnotatableFileMimeType["Png"] = "image/png";
  AnnotatableFileMimeType["Bmp"] = "image/bmp";
  AnnotatableFileMimeType["Tiff"] = "image/tiff";
  AnnotatableFileMimeType["Pdf"] = "application/pdf";
  return AnnotatableFileMimeType;
}({});
export var HotKeysToDisable = /*#__PURE__*/function (HotKeysToDisable) {
  HotKeysToDisable["A"] = "a";
  HotKeysToDisable["C"] = "c";
  HotKeysToDisable["O"] = "o";
  HotKeysToDisable["E"] = "e";
  HotKeysToDisable["F"] = "f";
  HotKeysToDisable["L"] = "l";
  HotKeysToDisable["R"] = "r";
  HotKeysToDisable["S"] = "s";
  HotKeysToDisable["G"] = "g";
  HotKeysToDisable["T"] = "t";
  HotKeysToDisable["H"] = "h";
  HotKeysToDisable["I"] = "i";
  HotKeysToDisable["N"] = "n";
  HotKeysToDisable["K"] = "k";
  HotKeysToDisable["U"] = "u";
  HotKeysToDisable["Q"] = "q";
  HotKeysToDisable["CTRL_P"] = "ctrl+P";
  HotKeysToDisable["COMMAND_P"] = "command+P";
  return HotKeysToDisable;
}({});
export var defaultOptions = {
  zoom: 1,
  disableDefaultPdfTronElements: false,
  disableFormInputs: true,
  additionalPdfTronElements: [],
  showNavigationArrows: false,
  editable: true,
  enablePdfFeatures: true,
  showPageNavOverlayButtons: false,
  webViewerLibPath: 'pdftron-webviewer/lib/',
  locale: 'en-us',
  useFetchApi: false,
  strings: {
    documentNotSupported: '** TO translate **',
    navigationButtonLeft: '',
    navigationButtonRight: '',
    pageNavOverlayButtonLeft: '',
    pageNavOverlayButtonRight: '',
    downloadButton: '',
    previewNotAvailable: '',
    movedOrDeletedErrorMessage: '',
    cannotBeSavedErrorMessage: '',
    serverErrorMessage: '',
    printButton: '',
    closeButton: '',
    documentLocked: '',
    printOptions: '',
    includeAnnotations: '',
    includeComments: '',
    addWatermark: '',
    placement: '',
    center: '',
    topLeft: '',
    topRight: '',
    topCenter: '',
    bottomLeft: '',
    bottomRight: '',
    bottomCenter: '',
    text: '',
    font: '',
    size: '',
    opacity: '',
    restoreDefaultSettings: '',
    add: '',
    cancel: '',
    fontStyle: '',
    downloadOptions: '',
    downloadAsPdf: '',
    printWarningMessage: ''
  },
  readonly: false,
  enableViewControlAndMenu: false,
  enablePrintHotKey: true,
  disableEditingOutlines: false
};
export var AnnotationDropDataTransferKey = 'annotationDrop';
export var AnnotationLocation = /*#__PURE__*/_createClass(function AnnotationLocation(coordinates, pageNumber) {
  _classCallCheck(this, AnnotationLocation);
  this.coordinates = coordinates;
  this.pageNumber = pageNumber;
});
export var AnnotationDescription = /*#__PURE__*/_createClass(function AnnotationDescription(location, metadata) {
  _classCallCheck(this, AnnotationDescription);
  this.location = void 0;
  this.metadata = void 0;
  this.location = location;
  this.metadata = metadata;
});
export var AlertType = /*#__PURE__*/function (AlertType) {
  AlertType["warning"] = "warning";
  AlertType["danger"] = "danger";
  return AlertType;
}({});
export var AlertLocation = /*#__PURE__*/function (AlertLocation) {
  AlertLocation["top"] = ".top-alerts-container";
  AlertLocation["bottom"] = ".bottom-alerts-container";
  return AlertLocation;
}({});
export var leftPanelElements = [PdfTronElement.leftPanel, PdfTronElement.leftPanelButton, PdfTronElement.outlinesPanel, PdfTronElement.thumbnailsPanelButton, PdfTronElement.outlinesPanelButton, PdfTronElement.thumbnailsPanel, PdfTronElement.thumbnailControl, PdfTronElement.thumbDelete, PdfTronElement.thumbRotateCounterClockwise, PdfTronElement.thumbRotateClockwise, PdfTronElement.documentControl, PdfTronElement.thumbMultiRotate, PdfTronElement.thumbMultiDelete, PdfTronElement.thumbExtract, PdfTronElement.pageAdditionalControlsHeader, PdfTronElement.moveToTop, PdfTronElement.moveToBottom, PdfTronElement.pageRotationHeader, PdfTronElement.rotatePageClockwise, PdfTronElement.rotatePageCounterClockwise, PdfTronElement.pageManipulationHeader, PdfTronElement.extractPage, PdfTronElement.deletePage, PdfTronElement.thumbnailsControlRotatePopupTrigger, PdfTronElement.thumbnailsControlExtract, PdfTronElement.thumbnailsControlDelete, PdfTronElement.thumbnailsControlManipulatePopupTrigger, PdfTronElement.editOutlineButton, PdfTronElement.addNewOutlineButtonContainer];
export var annotationsFeatureWebViewerElements = [PdfTronElement.notesPanel, PdfTronElement.toggleNotesButton, PdfTronElement.annotationCommentButton, PdfTronElement.annotationDeleteButton, PdfTronElement.notePopupState, PdfTronElement.menuOverlay, PdfTronElement.downloadButton];
export var highlightToolElements = [PdfTronElement.highlightToolGroupButton, PdfTronElement.highlightToolButton, PdfTronElement.highlightToolButton2, PdfTronElement.highlightToolButton3, PdfTronElement.highlightToolButton4, PdfTronElement.textHighlightToolButton];
export var freeTextToolElements = [PdfTronElement.freeTextToolGroupButton, PdfTronElement.toolsOverlay, PdfTronElement.toolStylePopup, PdfTronElement.stylePopup, PdfTronElement.opacitySlider, PdfTronElement.annotationStyleEditButton, PdfTronElement.annotationCommentButton, PdfTronElement.annotationDeleteButton, PdfTronElement.annotationStylePopup, PdfTronElement.freeTextToolButton, PdfTronElement.freeTextToolButton2, PdfTronElement.freeTextToolButton3, PdfTronElement.freeTextToolButton4, PdfTronElement.richTextPopup, PdfTronElement.richTextFormats, PdfTronElement.richTextBoldButton, PdfTronElement.richTextItalicButton, PdfTronElement.richTextUnderlineButton, PdfTronElement.richTextStrikeButton];
export var tickMarkToolElements = [PdfTronElement.blueTickMark, PdfTronElement.redTickMark, PdfTronElement.greenTickMark, PdfTronElement.yellowTickMark];
